import { apiInterfaceForJson,apiInterfaceForFormData } from '../common/apiManager';

export const getReportSettings = () => apiInterfaceForJson('/reportSettings/', 'GET', null);
export const saveReportSettings = (params) => apiInterfaceForJson('/reportSettings/', 'PUT', params);
export const setDefaultLab = (params) => apiInterfaceForJson('/reportSettings/default', 'POST', params);
export const previewReport = (params) => apiInterfaceForJson('/reportSettings/preview', 'POST', params);
